module.exports = __webpack_public_path__ + "img/img_02.99812341.png";